module.exports = __webpack_public_path__ + "img/gift.378aec76.svg";